import { Link, useLocation } from "@tanstack/react-router";
import { useEffect } from "react";
import "./styles.css";

export const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="not-found-container">
      {/* Animated background elements */}
      <div className="background-wrapper">
        <div className="bg-blob-1"></div>
        <div className="bg-blob-2"></div>
        <div className="bg-blob-3"></div>
        <div className="bg-blob-4"></div>
      </div>

      <div className="content-wrapper">
        {/* 404 Number with floating animation */}
        <div className="number-container">
          <h1 className="number-404">404</h1>
          <div className="circle-overlay">
            <div className="circle-inner">
              {/* <Search className="w-12 h-12 md:w-16 md:h-16 text-white/80" /> */}
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="text-content">
          <h2 className="title">Lost in Space</h2>
          <p className="description">
            Oops! It seems like you've drifted into the void. The page you're
            looking for has gone on an intergalactic adventure and can't be
            found in this universe.
          </p>

          {/* Action buttons */}
          <div className="button-group">
            <Link to="/" className="btn-primary">
              {/* <Home className="w-5 h-5" /> */}
              Return Home
            </Link>

            <button
              onClick={() => window.history.back()}
              className="btn-secondary"
            >
              {/* <ArrowLeft className="w-5 h-5" /> */}
              Go Back
            </button>
          </div>
        </div>

        {/* Floating elements */}
        <div className="floating-dot-1"></div>
        <div className="floating-dot-2"></div>
        <div className="floating-dot-3"></div>
      </div>
    </div>
  );
};
